import React from 'react';
import { SingleColumnFactbox } from '../../../../ui-components/data-viz-ui/factboxes/single-column-factbox/SingleColumnFactbox';
import { ComponentWithMeta } from '../../../common/component-utils';
import { KpiSingleColumnUiComponentProps } from './types';

export const KpiSingleColumnUiComponent = (
  props: KpiSingleColumnUiComponentProps
) => {
  const { meta, componentProps } = props;
  return (
    <ComponentWithMeta
      meta={meta}
      componentProps={componentProps}
      children={(props) => <SingleColumnFactbox {...props} />}
    />
  );
};
